
import React from "react";
import { Quote } from "lucide-react";

const quotes = [
  {
    text: "Good teaching and caring teachers.",
    name: "Anitha S.",
    color: "#FF6B6B",
  },
  {
    text: "My son's marks improved a lot.",
    name: "Rajesh Kumar",
    color: "#4ECDC4",
  },
  {
    text: "Classes are easy to understand.",
    name: "Deepa Mohan",
    color: "#FCA311",
  },
  {
    text: "Very good support for students.",
    name: "Sajitha R.",
    color: "#0B132B",
  },
  {
    text: "Teachers give personal attention.",
    name: "Praveen Nair",
    color: "#FF6B6B",
  },
  {
    text: "Excellent coaching and guidance.",
    name: "Lekha Haridas",
    color: "#4ECDC4",
  },
  {
    text: "Friendly atmosphere for learning.",
    name: "Mini Rajeev",
    color: "#FCA311",
  },
  {
    text: "Regular tests helped my daughter improve.",
    name: "Anil Kumar P.",
    color: "#0B132B",
  },
  {
    text: "One of the best tuition centres.",
    name: "Remya Mohan",
    color: "#FF6B6B",
  },
  {
    text: "Highly recommended for Plus One students.",
    name: "Shibu Thomas",
    color: "#4ECDC4",
  },
];

function Card({ q }) {
  return (
    <div
      className="testimonial-card shrink-0 w-[min(420px,85vw)] rounded-3xl p-7 sm:p-8 bg-white border border-[#0B132B]/8 shadow-[0_8px_30px_rgba(11,19,43,0.04)]"
      data-testid="testimonial-card"
    >
      <Quote size={28} style={{ color: q.color }} />
      <p className="mt-4 text-[#0B132B] text-lg leading-relaxed">"{q.text}"</p>
      <div className="mt-6 flex items-center gap-3">
        <div
          className="w-10 h-10 rounded-full grid place-items-center text-white font-bold"
          style={{ background: q.color }}
        >
          {q.name.charAt(0)}
        </div>
        <div>
          <div className="font-display font-bold text-[#0B132B]">{q.name}</div>
          {q.sub && <div className="text-xs text-[#758A9F]">{q.sub}</div>}
        </div>
      </div>
    </div>
  );
}

export default function Testimonials() {
  const looped = [...quotes, ...quotes];
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 sm:py-24 md:py-32 pb-24 sm:pb-28 md:pb-32"
      style={{ background: "var(--bg-primary)" }}
    >
      <div className="px-4 sm:px-6 md:px-12 lg:px-16 max-w-[1400px] mx-auto mb-12 sm:mb-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end">
          <div className="md:col-span-7">
            <div className="text-[11px] tracking-[0.25em] uppercase font-bold text-[#FF6B6B] mb-4">
              ✦ Voices of Nova
            </div>
            <h2 className="font-display font-black text-3xl sm:text-5xl md:text-6xl text-[#0B132B] tracking-tighter leading-[0.95]">
              Five years of <br />
              <span className="font-script font-medium text-[#FCA311]">happy growing-ups.</span>
            </h2>
          </div>
        </div>
      </div>

      <div
        className="marquee-pause marquee-scroll testimonials-marquee relative"
        data-testid="testimonials-marquee"
        aria-label="Testimonials carousel"
      >
        <div className="absolute left-0 top-0 bottom-0 w-12 sm:w-20 md:w-32 z-10 bg-gradient-to-r from-[#FDFBF7] to-transparent pointer-events-none" />
        <div className="absolute right-0 top-0 bottom-0 w-12 sm:w-20 md:w-32 z-10 bg-gradient-to-l from-[#FDFBF7] to-transparent pointer-events-none" />
        <div className="testimonials-track flex gap-6 animate-marquee w-max px-4 sm:px-6">
          {looped.map((q, i) => (
            <Card key={i} q={q} />
          ))}
        </div>
      </div>
    </section>
  );
}
